// NOTE: paragraphStyles hasn't been enabled in mobius froala config  https://froala.com/wysiwyg-editor/examples/paragraph-styles/
export const FROALA_CONFIG = {
	paragraphFormat: {
		N: "Normal",
		H2: "Heading 2",
		H3: "Heading 3",
		H4: "Heading 4"
	},
	linkStyles: {
		"btn": "Button"
	},
	paragraphStyles: {
		"standFirst": "Stand first"
	},
	linkNoOpener: false
}
const moreParagraphButtons = [
	"paragraphFormat",
	"alignLeft",
	"alignCenter",
	"alignRight",
	"formatOLSimple",
	"formatULSimple",
	"formatUL"
];
const moreTextButtons = [
	"paragraphStyle",
	"bold",
	"italic",
	"clearFormatting"
];
const moreMiscButtons = [
	"insertLink",
	"specialCharacters"
];
export const FLOALA_TOOLBAR_EXPANDED = {
	moreParagraph: {
		buttons: moreParagraphButtons,
		buttonsVisible: moreParagraphButtons.length,
	},
	moreText: {
		buttons: moreTextButtons,
		buttonsVisible: moreTextButtons.length,
	},
	moreMisc: {
		buttons: moreMiscButtons,
		buttonsVisible: moreMiscButtons.length,
	},
	unredo: { buttons: ["undo", "redo"] },
}
export const FLOALA_TOOLBAR_COLLAPSED = {
	moreText: { buttons: ["paragraphFormat", "bold", "italic", "insertLink"], buttonsVisible: 4 },
}